<app-navbar title="Ustawienie Strony - Menu Strony Głównej">
	<button class="me-4" mat-raised-button color="primary" (click)="save(data)">
		<i class="fas fa-check"></i>
		Zapisz
	</button>
	<button class="me-4" mat-raised-button color="primary" routerLink="./add">
		<i class="fas fa-plus"></i>
		Dodaj
	</button>
</app-navbar>

<mat-table #dataTable [dataSource]="data" cdkDropList (cdkDropListDropped)="dropTable($event)">
	<ng-container matColumnDef="id">
		<mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="name">
		<mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="link">
		<mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.link }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="isActive">
		<mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.status }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="edit">
		<mat-header-cell *matHeaderCellDef></mat-header-cell>
		<mat-cell *matCellDef="let element">
			<button mat-raised-button color="primary" routerLink="/www/menu/{{ element.id }}/">Edytuj</button>
		</mat-cell>
	</ng-container>
	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
</mat-table>
